import { render } from "./BaseDialogBox.vue?vue&type=template&id=2a3fbdce"
import script from "./BaseDialogBox.vue?vue&type=script&lang=js"
export * from "./BaseDialogBox.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gordonwong/Shedd/aerocle-client/aerocle-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__